<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
        <div class="row">
            <div class="col-12">
                <h1 class="title-default">Grupo de Empresas</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <mat-form-field appearance="outline">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="nomeEmpresaGrupo" type="text">
                    <mat-icon class="material-icons-outlined" matSuffix
                        matTooltip="O nome será usado para identificar o grupo de empresas">info_outline</mat-icon>
                    @if (model.get('nomeEmpresaGrupo')?.invalid) {
                    <mat-error>Informe um nome válido</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <app-select-pesquisavel label="Empresa Matriz" [control]="idEmpresaPrincipalControl"
                    [offlineList]="empresasParaSelect" [idField]="'idEmpresa'"
                    [nameField]="'nomeEmpresa'" [errorMessage]="'Selecione uma empresa principal'"
                    (searchChange)="onSearchEmpresa($event)" [secondaryField]="'cnpjFormatado'">
                </app-select-pesquisavel>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <button type="submit" mat-flat-button class="btn-primary button-big">
                    @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                    }
                    @else{
                    Salvar
                    }
                </button>
            </div>
        </div>
    </form>

    @if(this._dataSource && this._dataSource.data.length > 0) {
    <table mat-table [dataSource]="_dataSource">
        <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="nomeEmpresa">
            <th mat-header-cell *matHeaderCellDef> Nome da Empresa </th>
            <td mat-cell *matCellDef="let element"> {{element.nomeEmpresa}} </td>
        </ng-container>

        <ng-container matColumnDef="cnpj">
            <th mat-header-cell *matHeaderCellDef> CNPJ </th>
            <td mat-cell *matCellDef="let element"> {{element.cnpj | cnpj }} </td>
        </ng-container>

        <ng-container matColumnDef="matrizFilial">
            <th mat-header-cell *matHeaderCellDef> Matriz/Filial </th>
            <td mat-cell *matCellDef="let element"> {{element.idEmpresa == this.idEmpresaPrincipal ? 'Matriz' :
                'Filial'}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">
                <span [style.color]="element.isAtivo ? 'green' : 'red'" [style.fontWeight]="'500'">
                    {{element.isAtivo ? 'Ativo' : 'Inativo'}}
                </span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    } @else if (_isLoading === true) {
    <table>
        @for (item of [1,2,3]; track item) {
        <tr>
            <td>
                <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
            </td>
            <td>
                <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'"
                    [marginLeft]="'50'"></app-loading-box>
            </td>
            <td>
                <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"
                    [marginLeft]="'50'"></app-loading-box>
            </td>
            <td>
                <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"
                    [marginLeft]="'100'"></app-loading-box>
            </td>
            <td>
                <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"
                    [marginLeft]="'20'"></app-loading-box>
            </td>
        </tr>
        }
    </table>
    } @else if (this._dataSource?.data?.length === 0) {
    <app-empty-list [title]="'Não foi encontrado nenhuma empresa.'"></app-empty-list>
    }
</div>